import {
  Image
} from './Styles'

export type AvatarSize = "chat" | "small" | "userInfo" | "middle" | "large";
interface props {
  size: AvatarSize,
  src: string;
}

export default function Avatar({ size, src }: props) {

  let classes = []
  if (size)
    classes.push(size)

  return <Image className={classes.join(' ')} src={src} />
}